import 'Styles/templates/product.scss';

import pdpNew from '../vue/pdp-new';
import StickyBar from '../components/sticky-bar-new';
import productSliderApp from '../vue/product-slider/index';
import recentlyViewedApp from '../vue/recently-viewed/index';
import AutoplayVideo from '../components/autoplay-video';
import { initRecommendationReels } from '../recommendations';

pdpNew();
StickyBar();
productSliderApp();
recentlyViewedApp();
AutoplayVideo();

// When a program style is switched in place, the buy box swaps via Vue and the
// other PDP sections are re-rendered from the fetched page. Re-run the JS that
// powers those sections so they work against the fresh markup. Each initializer
// is isolated so one failure can't block the others.
const safeReinit = (label, fn) => {
  try {
    fn();
  } catch (error) {
    console.warn(`[pdp:sections-refreshed] ${label} failed`, error);
  }
};

window.addEventListener('pdp:sections-refreshed', () => {
  // Yotpo star rating under the title (new "Widgets" system).
  safeReinit('yotpo-widgets', () => {
    if (typeof window.refreshYotpoData === 'function') window.refreshYotpoData();
  });
  // Yotpo reviews list section (classic widget — different API).
  safeReinit('yotpo-classic', () => {
    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
    }
  });
  safeReinit('recommendations', () => initRecommendationReels());
  safeReinit('autoplay-video', () => AutoplayVideo());
  // The scroll sticky add-to-cart bar observes #sticky-show, which is recreated
  // when the buy box remounts — re-bind it to the fresh nodes.
  safeReinit('sticky-bar', () => StickyBar());
});
